export const worship = {
	GET_WORSHIP: "worship/get",
}

export default worship
